<template lang="pug">
api-form(
  :fields="fields"
  :method="signIn"
)
  template(#append-fields)
    v-hover(
      v-slot="{ hover}"
    )
      router-link(to="/forgot-password")
        p.caption.mb-4(
          :class="{ 'redesignPrimaryDarken--text': hover }"
        ) Забыли пароль?
    template(v-if="showCaptcha")
      validation-provider(
        name="captcha"
        rules="required"
        v-slot="{ errors }"
      )
        yandex-captcha-field(
          ref="captcha"
          v-model="captchaToken"
          :error-messages="errors"
          required
        )
  template(#save-btn="{ attrs, invalid, loading }")
    app-button(
      v-bind="attrs"
      :loading="loading"
      :disabled="invalid || (showCaptcha && !captchaToken)"
      rounded
      block
    ) Войти
</template>

<script>
import YandexCaptchaField from '@/components/ui-design/fields/YandexCaptchaField.vue';
import PasswordInput from '@/components/user-redesign/inputs/PasswordInput.vue';
import AppTextInput from '@/components/user-redesign/inputs/AppTextInput.vue';

const CAPTCHA_FIELD_RESPONSE_KEY = 'captcha';

export default {
  name: 'CredentialsTab',
  components: {
    YandexCaptchaField,
  },
  data() {
    return {
      showPassword: false,
      captchaToken: '',
      isCaptchaNeedToShow: false,
      fields: [
        {
          text: 'Имя пользователя',
          value: 'username',
          component: AppTextInput,
          rules: 'required|username',
          component_attrs: {
            'hide-details': false,
            placeholder: 'Логин или номер сертификата',
          },
        },
        {
          text: 'Пароль',
          value: 'password',
          rules: 'required|password',
          component: PasswordInput,
          component_attrs: {
            'hide-details': false,
          },
        },
      ],
    };
  },
  computed: {
    showCaptcha() {
      // on VCHT captcha requires always
      return this.$conf.isVcht || this.isCaptchaNeedToShow;
    },
  },
  watch: {},
  mounted() {},
  methods: {
    resetCaptcha() {
      this.$refs.captcha?.reset();
    },
    signIn({ data, obs }) {
      const payload = {
        ...data,
      };

      return this.$rApi.auth.authUserWithCredentials({ data: payload, obs }).then(({ response, error }) => {
        if (error) {
          const validation = error.response?.data?.validation || {};
          if (CAPTCHA_FIELD_RESPONSE_KEY in validation) {
            this.isCaptchaNeedToShow = true;
          }

          this.$nextTick(this.resetCaptcha);

          return { error };
        }

        this.$emit('auth', response);

        return { response };
      });
    },
  },
};
</script>
